module.exports = __webpack_public_path__ + "img/the-hidden-girl-and-other-stories.ded6b3fd.png";